/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Email_ProviderInputs */

const en_admin_settings_fields_email_provider = /** @type {(inputs: Admin_Settings_Fields_Email_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Provider`)
};

const zh_admin_settings_fields_email_provider = /** @type {(inputs: Admin_Settings_Fields_Email_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮件服务商`)
};

/**
* | output |
* | --- |
* | "Email Provider" |
*
* @param {Admin_Settings_Fields_Email_ProviderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_email_provider = /** @type {((inputs?: Admin_Settings_Fields_Email_ProviderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Email_ProviderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_email_provider(inputs)
	return zh_admin_settings_fields_email_provider(inputs)
});
export { admin_settings_fields_email_provider as "admin.settings.fields.email_provider" }